import { fetchNoToken, fetchFileWithToken } from "../helpers/fetch";
import { AppRoutes } from "../routes";
import { userActions } from "../store/userSlice";
import { showSimpleMessage } from "./ui";

export const requestRecoveryPassword = (email) => {
  return async (dispatch) => {
    try {
      dispatch(userActions.setRecoveryLoading(true));
      try {
        const data = {
          user: {
            email: email,
          },
        };
        const response = await fetchNoToken(
          "api/forgot_password",
          data,
          "POST"
        );
        const body = await response.json();
        console.log(body);
        const errors = body.status !== "ok";
        if (errors) {
          console.log("Error:", body);
        } else {
          console.log("Response:", body);
          dispatch(
            showSimpleMessage("Correo de recuperacion", "Se ha enviado correo")
          );
          dispatch(userActions.setRecoveryLoading(false));
          dispatch(userActions.setRedirectTo(AppRoutes.LOGIN));
          dispatch(userActions.setRecoveryEmail(null));
        }
      } catch (error) {
        console.log("Exception:", error);
      }
    } catch (error) {
      console.log("Exception:", error);
    }
  };
};

export const validateToken = (token) => {
  return async (dispatch) => {
    dispatch(userActions.setRecoveryLoading(true));
    try {
      const data = {
        user: {
          reset_password_token: token,
        },
      };
      const response = await fetchNoToken("api/validate_token", data, "POST");
      const body = await response.json();
      console.log(body);
      if (body.status !== "ok") {
        dispatch(userActions.setRecoveryValidToken(false));
      } else {
        dispatch(userActions.setRecoveryValidToken(true));
      }
      dispatch(userActions.setRecoveryLoading(false));
    } catch (error) {
      console.log("Exception:", error);
    }
  };
};

export const reset = (token, password, password_confirmation) => {
  return async (dispatch) => {
    dispatch(userActions.setRecoveryLoading(true));
    try {
      const data = {
        user: {
          reset_password_token: token,
          password: password,
          password_confirmation: password_confirmation,
        },
      };
      const response = await fetchNoToken("api/reset", data, "PUT");
      const body = await response.json();
      console.log(body);
      if (body.status !== "ok") {
        dispatch(userActions.setRecoveryValidToken(false));
      } else {
        dispatch(
          showSimpleMessage(
            "Cambio exitoso",
            "La contraseña se cambio exitosamente"
          )
        );
        dispatch(userActions.setRecoveryValidToken(true));
        dispatch(userActions.setRedirectTo(AppRoutes.LOGIN));
      }
      dispatch(userActions.setRecoveryLoading(false));
    } catch (error) {
      console.log("Exception:", error);
    }
  };
};

export const isValidLessee = (national_id_number, contract_number) => {
  return async (dispatch) => {
    dispatch(userActions.setRegisterLoading(true));
    try {
      const data = {
        register: {
          national_id_number: national_id_number,
          contract_number: contract_number,
        },
      };
      const response = await fetchNoToken("api/is_valid_lessee", data, "POST");
      const body = await response.json();
      console.log(body);
      if (body.status !== "ok") {
        dispatch(userActions.setRedirectTo(null));
        dispatch(
          showSimpleMessage(
            "Informacion invalida",
            "Porfavor valide la informacion"
          )
        );
      } else {
        dispatch(userActions.setRedirectTo(AppRoutes.UPDATE_BASIC_DATA));
      }
      dispatch(userActions.setRegisterLoading(false));
    } catch (error) {
      console.log("Exception:", error);
    }
  };
};

export const updateContactInfo = (
  email,
  cellphone,
  idNumber,
  contractNumber
) => {
  return async (dispatch) => {
    dispatch(userActions.setRegisterLoading(true));
    try {
      const data = {
        register: {
          email: email,
          cellphone: cellphone,
          national_id_number: idNumber,
          contract_number: contractNumber,
        },
      };
      const response = await fetchNoToken("api/register", data, "POST");
      const body = await response.json();
      console.log(body);
      if (body.status !== "ok") {
        dispatch(userActions.setRedirectTo(null));
      } else {
        dispatch(userActions.setRedirectTo(AppRoutes.LOGIN));
        dispatch(
          showSimpleMessage(
            "Se ha creado su cuenta",
            "Se ha enviado correo para actualizar contraseña"
          )
        );
      }
      dispatch(userActions.setRegisterLoading(false));
    } catch (error) {
      console.log("Exception:", error);
    }
  };
};

export const upload_receipt = (data) => {
  return async (dispatch) => {
    try {
      console.log("before fetch with token");
      const response = await fetchFileWithToken(
        "api/v1/upload_receipt",
        data,
        "POST"
      );
      const body = await response.json();
      console.log(body);
      if (body.status !== "ok") {
        console.log("Error:" + body);
      } else {
        console.log(body);
      }
    } catch (error) {
      console.log("Exception:", error);
    }
  };
};
